import * as audioActions from '../../actions/early/audio'
import * as h2Api from '../../h2Api'
import * as earlyListingActions from '../../actions/early/earlyListing'

const initialState = {
  audioComponentId: 'earlyAudio', //`audiocomponent${Math.random()}`,
  timings: [],
  prevWord: '',
  playing: false,
  ended: false,
  timerId: null,
  autoPlay: true,
  registeredPlayers: []
}
const audio = (state = initialState, action) => {
  switch (action.type) {
    case audioActions.SET_AUTOPLAY_STATE:
      return {
        ...state,
        autoPlay: action.value
      }

    case audioActions.TOGGLE_IS_AUDIO_PLAYING:
      return {
        ...state,
        playing: action.isAudioPlaying
      }

    case earlyListingActions.LOAD_GAME:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          autoPlay: action.restCall.result.autoPlay
        }
      }

      return state

    case audioActions.REGISTER_PLAYER:
      return {
        ...state,
        registeredPlayers: [...state.registeredPlayers, action.value]
      }
    case audioActions.UNREGISTER_PLAYER:
      return {
        ...state,
        registeredPlayers: state.registeredPlayers.filter(f => f != action.value)
      }

    case audioActions.SET_TIMINGS:
      return {
        ...state,
        timings: action.value
      }
    case audioActions.TIMINGS_PREV_WORD:
      return {
        ...state,
        prevWord: action.prevWord
      }

    case audioActions.PLAYER_STATE:
      return {
        ...state,
        playing: action.playing,
        ended: action.ended,
        timerId: action.timerId
      }

    default:
      return state
  }
}

export default audio
